/**
 * Central ZAR rules for fiat withdrawal UI. Prefer API-driven `minWithdrawal` when present;
 * use these when the backend does not return a value (see WithdrawParent business path).
 */
export const FIAT_EXPRESS_WITHDRAWAL_MIN_ZAR = 60;

/** Fallback when `data.minWithdrawal` is unavailable (e.g. business ZAR until API exposes it). */
export const FIAT_DEFAULT_MIN_WITHDRAWAL_ZAR = FIAT_EXPRESS_WITHDRAWAL_MIN_ZAR;
